import { useState } from "react";
import type { CorralFilterFormState } from "../corral.types";

export function useFilterForm() {
  const [filterForm, setFilterForm] = useState<CorralFilterFormState>({
    searchText: "",
  });

  const handleChangeFilter = <T extends keyof CorralFilterFormState>(
    field: T,
    value: CorralFilterFormState[T]
  ) => {
    setFilterForm((prev) => ({ ...prev, [field]: value }));
  };

  return {
    filterForm,
    handleChangeFilter,
  };
}
